import React from 'react'
import './Experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">

    <div className="experience_frontend">
    <h3>Frontend Development</h3>
    <div className="experience_content">
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>HTML 5</h4>
        <small className='text-light'>Experienced</small>
        </div>


      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>CSS 3</h4>
        <small className='text-light'>Intermediate</small>

        </div>
      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>JavaScript</h4>
        <small className='text-light'>Experienced</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>React JS</h4>
        <small className='text-light'>Experienced</small>

        </div>
      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Redux</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Chakra UI</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>TypeScript</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>BootStrap</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
    </div>
    </div>

{/* ============================= */}


    <div className="experience_backend">

    <h3>Backend Development</h3>
    <div className="experience_content">
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Node JS</h4>
        <small className='text-light'>Experienced</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Express JS</h4>
        <small className='text-light'>Experienced</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Mongo DB</h4>
        <small className='text-light'>Experienced</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>MySQL</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>AWS</h4>
        <small className='text-light'>Intermediate</small>
        </div>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <div>

        <h4>Firebase</h4>
        <small className='text-light'>Beginner</small>
        </div>

      </article>
      {/* <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <h4>TypeScript</h4>
        <small className='text-light'>Intermediate</small>

      </article>
      <article className='experience_details'>
        <BsPatchCheckFill className='experience_details-icon'/>
        <h4>BootStrap</h4>
        <small className='text-light'>Intermediate</small>

      </article> */}
    </div>
    


    </div>

      </div>
    </section>
  )
}

export default Experience